import React from "react";
import SuperAdminAnnouncements from "../superadmin/communication/AnnouncementsPage";

const AnnouncementsPage = () => {
    return <SuperAdminAnnouncements />;
};

export default AnnouncementsPage;
